// LE-034: botão de login com Google via Google Identity Services (GIS).
// - Só renderiza quando REACT_APP_GOOGLE_CLIENT_ID está definido no build
//   (o plano mestre: botão NÃO aparece enquanto o login Google estiver
//   desabilitado/ sem credenciais — nenhuma mudança visual no estado atual).
// - O frontend apenas OBTÉM a credential (ID token); a verificação é 100%
//   server-side em POST /api/auth/google (nunca se confia no cliente).
// - O texto do botão é localizado automaticamente pelo Google conforme o
//   idioma do navegador (ex.: "Fazer login com o Google" em pt-BR).
import React, { useEffect, useRef } from 'react';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export function GoogleLoginButton({ onSuccess, onError }) {
  const containerRef = useRef(null);
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);
  onSuccessRef.current = onSuccess;
  onErrorRef.current = onError;

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return undefined;

    let cancelled = false;

    function init() {
      if (cancelled || !window.google?.accounts?.id || !containerRef.current) return;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        ux_mode: 'popup',
        callback: async (response) => {
          try {
            const credential = response?.credential;
            if (!credential) throw new Error('Credencial do Google ausente');
            await onSuccessRef.current(credential);
          } catch (err) {
            onErrorRef.current?.(err);
          }
        },
      });
      window.google.accounts.id.renderButton(containerRef.current, {
        theme: 'outline',
        size: 'large',
        shape: 'pill',
        text: 'continue_with',
        width: '100%',
      });
    }

    if (window.google?.accounts?.id) {
      init();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = init;
      script.onerror = () => onErrorRef.current?.(new Error('Falha ao carregar o login do Google'));
      document.head.appendChild(script);
    }

    return () => {
      cancelled = true;
    };
  }, []);

  if (!GOOGLE_CLIENT_ID) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--nc-text-muted)', fontSize: 12 }}>
        <span style={{ flex: 1, height: 1, background: 'var(--nc-border)' }} />
        ou continue com
        <span style={{ flex: 1, height: 1, background: 'var(--nc-border)' }} />
      </div>
      <div ref={containerRef} style={{ display: 'flex', justifyContent: 'center' }} />
    </div>
  );
}
